import * as React from 'react';
import HeaderedContent from 'components/HeaderedContent';
import * as classes from './UnsupportedBrowser.scss';
import * as intl from 'react-intl-universal';
import logo from 'assets/chrome-logo.svg';

const targetUrl = 'https://www.google.com/chrome/browser';

const UnsupportedBrowser: React.FunctionComponent = () => {
  return (
    <HeaderedContent
      isFooterVisible={true}
      isHelpVisible={false}
    >
      <div className={classes.content}>
        <a href={targetUrl}>
          <img src={logo} className={classes.logo} />
        </a>
        <div className={classes.title}>{intl.get('unsupported_browser_title')}</div>
        <div className={`font-size-xs ${classes.subTitle}`}>{intl.getHTML('unsupported_browser_subtitle', { targetUrl })}</div>
      </div>
    </HeaderedContent>
  );
};

export default UnsupportedBrowser;



// WEBPACK FOOTER //
// ./src/components/UnsupportedBrowser.tsx